import Hero from '../components/home/Hero'
import VisionManifesto from '../components/home/VisionManifesto'
import WelfareShowcase from '../components/home/WelfareShowcase'
import Services from '../components/home/Services'
import Adoption from './Adoption'
import AdoptionStories from '../components/home/AdoptionStories'
import Volunteer from './Volunteer'
import RabiesHub from '../components/home/RabiesHub'
import AwarenessCtaBanner from '../components/home/AwarenessCtaBanner'
import HowToHelp from '../components/home/HowToHelp'
import SponsorBanner from '../components/SponsorBanner'
import Moments from '../components/home/Moments'

const Home = ({ onOpenDonate }) => {
  return (
    <div className="space-y-2">
      {/* 1. Hero Section */}
      <Hero />

      {/* 2. Vision & Manifesto */}
      <VisionManifesto />

   

      <AdoptionStories />
      {/* 4. Adoption Section */}
      <Adoption onOpenDonate={onOpenDonate} />

      {/* 4. Stories of Adopted Pets & Adopters */}

      {/* 5. Core Services (Comprehensive Care in Action) - Moved further down */}
      {/* <Services /> */}

      {/* Passive Adoption Sponsor Banner */}

  <WelfareShowcase />
      {/* 6. Volunteer Section */}
      <Volunteer />
      {/* 7. Rabies Prevention & Interactive Bite Protocol */}
      <RabiesHub />

      {/* 8. Awareness Program Workshop CTA Banner for Schools & RWAs */}
      <AwarenessCtaBanner />

      <HowToHelp onOpenDonate={onOpenDonate} />
      <SponsorBanner onOpenDonate={onOpenDonate} />


      {/* 9. Gallery of Happy Adoption Moments */}
      {/* <Moments /> */}

    </div>
  )
}

export default Home
